import type { IconSvgObject } from './types';

const BookmarkMinus01Icon: IconSvgObject = [
  ["path", { d: "M21 5.5H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 7.5H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 2.5H5C3.89543 2.5 3 3.39543 3 4.5V21.5L10.5 17.5L18 21.5V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BookmarkMinus01Icon;
